const figures = {
    "2": {
        "image": "./figures/cp_build.png",
        "caption": "Center-Left: input image; Left: 2D Lego Mosaic output; Right: 3D LEGO® Model output and corresponding build process.",
        "width": "80%"
    },
    "3": {
        "image": "./figures/sketch_example.png",
        "caption": "Left: input sketch; Center: 2D face image; Right: 3D face LEGO®.",
        "width": "80%",
        "maxWidth": "600px"
    },
    "4": {
        "image": "./figures/full_architecture.png",
        "caption": "Our TL-Octree network, consisting of a 3D model autoencoder and an image encoder. At train time, we optimize the autoencoder eights for reconstruction of the voxelized 3D models. We additionally minimize the mean squared error between the latent representations of this encoder and those produced by the image encoder from a corresponding 2D image. At test time, we compose the image encoder with the 3D decoder network to produce a voxelized 3D model from an image. Finally, we algorithmically produce a matching LEGO® approximation.",
        "width": "80%"
    },
    "5": {
        "image": "./figures/optimization.png",
        "caption": "Depiction of Autoencoder training and validation loss as a function of iteration number for different channel numbers. An input image and reconstructed output for each architecture is depicted for visual interpretation of the loss.",
        "width": "80%"
    },
    "7": {
        "image": "./figures/results_a.png",
        "caption": "Example results: an input image that our model renders as voxels, from which we then produce a LEGO® version (target voxelized object shown at right).",
        "width": "80%"
    },
    "7": {
        "image": "./figures/cp_legov.png",
        "caption": "A sample of LEGO® build instruction steps with an image of a face. Top: The internal structure is hollow, which leads to practical build challenges. Bottom: to mitigate this, we modify the original algorithm to fill in the structure with additional bricks.",
        "width": "80%",
        "maxWidth": "600px"
    },
    "8": {
        "image": "./figures/results_b.png",
        "caption": "Example results: variable resolution LEGO® arrangements from one given gray-scale image of an airplane. The mid-resolution airplane is physically build using real LEGO® bricks, as shown on the right.",
        "width": "80%"
    },
    "9": {
        "image": "./figures/chair_example.png",
        "caption": "The full pipeline of our model: we input a photograph and apply background matting first, as a preprocessing step. Our model then takes this as input and produces a 3D voxel grid. We then supply this to an algorithm that maps it to a LEGO® structure. The output resolution is flexible, offering opportunities to construct plausible LEGO® models at different levels of effort, expertise, and availability ofbricks for construction.",
        "width": "80%"
    },
    "10": {
        "image": "./figures/dalle_example.png",
        "caption": "An example representation of the capabilities for combining our system with DALL-E to produce LEGO® modelsfrom written descriptions. The DALL-E model produces an image of a chair based on a description provided by the user, following which the image of the chair is converted to a 3D LEGO® model by our program.",
        "width": "80%"
    }
};

export default figures;